import React, { useState } from 'react';
import styled from 'styled-components/macro';

import DesktopHeader from './components/DesktopHeader/DesktopHeader';
import MobileHeader from './components/MobileHeader/MobileHeader';

const MainContainer = styled.div`
  padding: ${props => props.theme.header.mobile.paddingY}px ${props => props.theme.padding.contentXPercent}%;
  height: 80px;
  position: absolute;
  width: 100%;
  z-index: 100;
  background-color: ${props => props.theme.color.primary};

  @media (min-width: 768px) {
    padding: 0px ${props => props.theme.padding.contentXPercent}%;
    height: auto;
    position: fixed;
  }
`;

const Header = () => {
  const [isCollapsed, toggleCollapsed] = useState(true);
  return (
    <MainContainer>
      <DesktopHeader />
      <MobileHeader isCollapsed={isCollapsed} onCollapse={() => toggleCollapsed(!isCollapsed)} />
    </MainContainer>
  );
};

export default Header;
